// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3xjXT","gfeWrapper":"CalendarEvent_gfeWrapper__2rmlV"};